module.exports = __webpack_public_path__ + "static/media/template-icon.2287ee54.svg";